document.querySelectorAll('.ritual-philosophy-hero').forEach((section) => {
  const revealEls = section.querySelectorAll('[data-reveal]');

  if (revealEls.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    revealEls.forEach((el) => observer.observe(el));
  }

  const heading = section.querySelector('[data-bouncy-heading]');
  if (!heading) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  let replayInterval = null;

  const replay = () => {
    heading.classList.remove('is-bouncing');
    // Force reflow so the animation restarts.
    void heading.offsetWidth;
    heading.classList.add('is-bouncing');
  };

  const headingObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          replay();
          if (!replayInterval) {
            replayInterval = window.setInterval(replay, 30000);
          }
        } else if (replayInterval) {
          window.clearInterval(replayInterval);
          replayInterval = null;
        }
      });
    },
    { threshold: 0.15 }
  );

  headingObserver.observe(heading);
});
